import React from 'react';
import { Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
const Settings = () => {
  return <div className="w-full py-8">
    <Outlet />
  </div>;
};
export default Settings;